var map = {
	"./365.png": "4b35",
	"./ALPACABNB.png": "3afa",
	"./ALPACABUSD.png": "1525",
	"./ALPHABNB.png": "4622",
	"./BANDBNB.png": "b0f7",
	"./BNB.png": "cb21",
	"./BTC.png": "5668",
	"./BUSD.png": "af16",
	"./CAKEBNB.png": "80e7",
	"./CRD.png": "af1a",
	"./CTKBNB.png": "4af5",
	"./DOGE.png": "fa7d",
	"./ETH.png": "90b3",
	"./HBX.png": "f282",
	"./HBXBNB.png": "4201",
	"./HBXDOGE.png": "bbf8",
	"./MGOOGLUST.png": "a3cc",
	"./MNFLXUST.png": "e264",
	"./MTSLAUST.png": "7449",
	"./POOLBONUS.png": "0015",
	"./REBATE.png": "3bac",
	"./S19THs.png": "030c",
	"./S9THs.png": "ffd8",
	"./SFPBNB.png": "e4c9",
	"./SWOP.png": "6aa7",
	"./THB.png": "aa47",
	"./THBX.png": "81f9",
	"./TUSD.png": "7876",
	"./VOLTZ.png": "5ab7",
	"./XRPBNB.png": "f0ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e062";